<template>
    <b-overlay :show="loading || updating" rounded="sm" class="h-100">
        <div class="card mb-0 h-100">
            <div class="card-body">
                <div class="d-flex flex-wrap" :class="{ 'flex-column': navTabs }">
                    <h5 class="card-title header-title flex-grow-10 mb-3">
                        {{ title }}
                    </h5>
                    <ul v-if="navTabs || Object.keys(data).length > 1" class="nav card-nav mb-3" :class="{ 'nav-tabs': navTabs }">
                        <li v-for="chartType in Object.keys(data)" :key="chartType" class="nav-item">
                            <a href="#" class="nav-link" :class="{ active: chartType === currentChart }" @click.prevent="selectChart(chartType)">
                                <h6 class="fs-14" :class="{ 'text-muted': chartType !== currentChart }">
                                    {{ data[chartType].name }}
                                </h6>
                                <h3 v-if="navTabs">{{ data[chartType].value }}</h3>
                            </a>
                        </li>
                    </ul>
                </div>

                <EChart
                    :card="false"
                    :loading="loading || updating"
                    :error="null"
                    :options="currentOption"
                    :type="type"
                    :height="height"
                    :group-by="groupBy"
                />
            </div>
        </div>
    </b-overlay>
</template>

<script>
    import EChart from '@/components/common/EChart.vue';

    export default {
        name: 'MultiEChartCard',
        components: { EChart },
        props: {
            data: {
                type: Object,
                required: true,
            },
            height: {
                type: [Number, String],
                default: 300,
            },
            type: {
                type: String,
                default: 'bar',
            },
            loading: {
                type: Boolean,
                default: false,
            },
            title: {
                type: String,
                default: '',
            },
            navTabs: {
                type: Boolean,
                default: false,
            },
            range: {
                type: String,
            },
            groupBy: {
                type: String,
                default: 'day',
            },
        },
        data() {
            return {
                currentChart: Object.keys(this.data)[0],
                updating: false,
            };
        },
        computed: {
            currentOption() {
                return this.data[this.currentChart];
            },
        },
        methods: {
            selectChart(type) {
                if (type === this.currentChart) return;
                this.updating = true;
                this.currentChart = type;
                this.$emit('currentChart', type);
                this.$nextTick(() => {
                    this.updating = false;
                });
            },
        },
    };
</script>
